"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@veeam/core");
var TabList_1 = require("../../../TabList");
var WizardTabsViewController = /** @class */ (function (_super) {
    __extends(WizardTabsViewController, _super);
    function WizardTabsViewController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = new Map();
        return _this;
    }
    WizardTabsViewController.prototype.createElement = function (navigation) {
        var _this = this;
        return (react_1.default.createElement(TabList_1.TabList, { width: this.width, items: navigation.map(function (_a) {
                var id = _a.id, active = _a.active, disabled = _a.disabled;
                return ({
                    onClick: function () {
                        if (!disabled) {
                            _this.listener && _this.listener.didSelectStepById(id);
                        }
                    },
                    active: active,
                    disabled: disabled,
                    render: function () { return _this.getTabElement(id); }
                });
            }) }));
    };
    WizardTabsViewController.prototype.present = function (state) {
        this.setState(state);
    };
    WizardTabsViewController.prototype.getTabElement = function (id) {
        var tab = this.tabs.get(id);
        if (!tab) {
            return null;
        }
        return tab.render() || null;
    };
    WizardTabsViewController.prototype.registerTab = function (id, viewController) {
        this.tabs.set(id, viewController);
    };
    return WizardTabsViewController;
}(core_1.ReactViewController));
exports.WizardTabsViewController = WizardTabsViewController;
//# sourceMappingURL=WizardTabsViewController.js.map